import { Outlet, NavLink } from 'react-router-dom';
import { useHubTabs } from '@/lib/permisos';
import { Share2, Calendar, TrendingUp } from 'lucide-react';

const TABS = [
  { key: 'publicaciones', path: '/tenant/social-ads/publicaciones', label: 'Publicaciones', icon: Calendar, end: true, module: 'social' },
  { key: 'meta-ads', path: '/tenant/social-ads/meta-ads', label: 'Meta Ads', icon: TrendingUp, module: 'meta_ads' },
];

export default function SocialAdsHubLayout() {
  const { tabs: visibleTabs } = useHubTabs(TABS);
  return (
    <div className="space-y-4" data-testid="social-ads-hub">
      <div>
        <h1 className="text-lg font-bold text-[#0F172A] flex items-center gap-2">
          <Share2 className="w-5 h-5" /> Social & Ads
        </h1>
        <p className="text-sm text-[#64748B]">Programa publicaciones y administra tus campañas de anuncios en un solo lugar</p>
      </div>
      <div className="flex gap-1 border-b border-[#E2E8F0] overflow-x-auto" data-testid="social-ads-hub-tabs">
        {visibleTabs.map(tab => (
          <NavLink key={tab.key} to={tab.path} end={tab.end}
            data-testid={`social-ads-tab-${tab.key}`}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3 py-2.5 text-xs font-medium border-b-2 whitespace-nowrap transition-colors ${
                isActive ? 'border-[#F72585] text-[#0F172A]' : 'border-transparent text-[#64748B] hover:text-[#0F172A]'}`}>
            <tab.icon className="w-3.5 h-3.5" /> {tab.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
